// S1000D Standard Numbering System (SNS) codes extracted from SNS.pdf
// Used for System Code dropdown in DML Builder

export const SNS_CODES = [
  { code: "00", name: "Product - General" },
  { code: "04", name: "Worthiness (fit for purpose) limitations" },
  { code: "05", name: "Scheduled/unscheduled maintenance" },
  { code: "06", name: "Dimensions and areas" },
  { code: "07", name: "Lifting, shoring, recovering and transporting" },
  { code: "08", name: "Leveling and weighing" },
  { code: "09", name: "Handling and maneuvering" },
  { code: "10", name: "Parking, mooring, storing and return to service" },
  { code: "11", name: "Placards and markings" },
  { code: "12", name: "Servicing" },
  { code: "14", name: "Product loading and offloading" },
  { code: "15", name: "Crew information" },
  { code: "16", name: "Change of role" },
  { code: "18", name: "Vibration and noise analysis and attenuation" },
  { code: "20", name: "Standard practices - Airframe systems" },
  { code: "21", name: "Environmental control" },
  { code: "22", name: "Auto flight" },
  { code: "23", name: "Communications" },
  { code: "24", name: "Electrical power" },
  { code: "25", name: "Equipment/Furnishings" },
  { code: "26", name: "Fire protection" },
  { code: "27", name: "Flight controls" },
  { code: "28", name: "Fuel" },
  { code: "29", name: "Hydraulic power" },
  { code: "30", name: "Ice and rain protection" },
  { code: "31", name: "Indicating/Recording systems" },
  { code: "32", name: "Landing gear" },
  { code: "33", name: "Lights" },
  { code: "34", name: "Navigation" },
  { code: "35", name: "Oxygen" },
  { code: "36", name: "Pneumatic" },
  { code: "37", name: "Vacuum" },
  { code: "38", name: "Water/Waste" },
  { code: "39", name: "Attack system management" },
  { code: "40", name: "Operational attack functions" },
  { code: "41", name: "Water ballast" },
  { code: "42", name: "Integrated modular avionics" },
  { code: "43", name: "Tactical communications" },
  { code: "44", name: "Cabin System" },
  { code: "45", name: "Central maintenance system (CMS)" },
  { code: "46", name: "Information system" },
  { code: "47", name: "Liquid nitrogen" },
  { code: "48", name: "In-flight refueling tanker" },
  { code: "49", name: "Airborne auxiliary power" },
  { code: "50", name: "Cargo and accessory compartment" },
  { code: "51", name: "Standard practices - Structures" },
  { code: "52", name: "Doors" },
  { code: "53", name: "Fuselage" },
  { code: "54", name: "Nacelles/Pylons" },
  { code: "55", name: "Stabilizers" },
  { code: "56", name: "Windows and canopies" },
  { code: "57", name: "Wings" },
  { code: "60", name: "Standard practices - Propeller/Rotor" },
  { code: "61", name: "Propellers/Propulsors" },
  { code: "62", name: "Main rotors" },
  { code: "63", name: "Main rotor drives" },
  { code: "64", name: "Tail rotor" },
  { code: "65", name: "Tail rotor drive" },
  { code: "66", name: "Folding blades/pylon" },
  { code: "67", name: "Rotors flight control" },
  { code: "68", name: "Integrated flight and propulsion controls" },
  { code: "70", name: "Standard practices - Engine" },
  { code: "71", name: "Power plant" },
  { code: "72", name: "Engine" },
  { code: "73", name: "Engine fuel and control" },
  { code: "74", name: "Ignition" },
  { code: "75", name: "Air" },
  { code: "76", name: "Engine controls" },
  { code: "77", name: "Engine indicating" },
  { code: "78", name: "Exhaust" },
  { code: "79", name: "Oil" },
  { code: "80", name: "Starting" },
  { code: "81", name: "Turbines" },
  { code: "82", name: "Water injection" },
  { code: "83", name: "Accessory gearboxes" },
  { code: "84", name: "Propulsion augmentation" },
  { code: "85", name: "Fuel cell system" },
  { code: "86", name: "Lift system" },
  { code: "87", name: "Propulsion battery" },
  { code: "90", name: "Recovery" },
  { code: "91", name: "Air vehicle wiring" },
  { code: "92", name: "Radar" },
  { code: "93", name: "Surveillance" },
  { code: "94", name: "Weapons system" },
  { code: "95", name: "Crew escape and safety" },
  { code: "96", name: "Missiles, drones and telemetry" },
  { code: "97", name: "Image recording" },
  { code: "98", name: "Meteorological and atmospheric research" },
  { code: "99", name: "Electronic warfare" },
];

// Ground/Land vehicle SNS codes
export const SNS_CODES_LAND = [
  { code: "A0", name: "Propulsion" },
  { code: "A1", name: "Power pack" },
  { code: "A2", name: "Power unit" },
  { code: "A3", name: "Engine cooling system" },
  { code: "A4", name: "Fuel systems" },
  { code: "A5", name: "Air and exhaust systems" },
  { code: "A6", name: "Lubrication systems" },
  { code: "A7", name: "Transmission" },
  { code: "A8", name: "Automotive/remote piloting and digital control systems" },
  { code: "A9", name: "Controls (drivers)" },
  { code: "B0", name: "Structure" },
  { code: "B1", name: "Hull/frame" },
  { code: "B2", name: "Body/cab" },
  { code: "B3", name: "Suspension/track/wheels" },
  { code: "B4", name: "Turret assembly" },
  { code: "B5", name: "Structures and buildings" },
  { code: "B6", name: "Sites" },
  { code: "B7", name: "Masts" },
  { code: "B8", name: "Containers" },
  { code: "C0", name: "Armaments" },
  { code: "D0", name: "Electrical systems" },
  { code: "D1", name: "Electrical systems (engine/power pack)" },
  { code: "D2", name: "Electrical systems (hull/frame)" },
  { code: "D3", name: "Electrical systems (body/cab)" },
  { code: "D4", name: "Electrical systems (turret)" },
  { code: "D5", name: "Power supply" },
  { code: "E0", name: "Communications" },
  { code: "E1", name: "Communications systems" },
  { code: "E2", name: "Connectivity" },
  { code: "E3", name: "Antennas" },
  { code: "E4", name: "Tempest" },
  { code: "F0", name: "Navigation" },
  { code: "F1", name: "Navigation systems" },
  { code: "G0", name: "Surveillance" },
  { code: "G1", name: "Surveillance systems" },
  { code: "H0", name: "Steering" },
  { code: "H1", name: "Steering systems" },
  { code: "J0", name: "Ventilation cooling and heating" },
  { code: "J1", name: "Ventilation cooling and heating systems" },
  { code: "K0", name: "Hydraulic systems" },
  { code: "K1", name: "Hydraulics" },
  { code: "K2", name: "Pneumatic systems" },
  { code: "L0", name: "Electronic system" },
  { code: "L1", name: "Electronics" },
  { code: "M0", name: "Auxiliary" },
  { code: "M1", name: "Auxiliary systems" },
  { code: "M2", name: "Adapter kits" },
  { code: "M3", name: "Fire" },
  { code: "N0", name: "Survivability" },
  { code: "N1", name: "Surface finish" },
  { code: "N2", name: "Intrusion" },
  { code: "N3", name: "Nuclear, biological and chemical" },
  { code: "P0", name: "Special equipment" },
  { code: "P1", name: "Special to type equipment" },
  { code: "P2", name: "Special recovery equipment" },
  { code: "P3", name: "Special fit equipment" },
  { code: "P4", name: "Special purpose equipment" },
  { code: "Q0", name: "Outfit and furnishings" },
  { code: "Q1", name: "Stowage" },
  { code: "Q2", name: "Complete equipment schedule (CES)" },
  { code: "R0", name: "Training" },
  { code: "R1", name: "Training services" },
  { code: "S0", name: "Repair test and support" },
  { code: "S1", name: "Repair facilities" },
  { code: "S2", name: "Common support equipment" },
  { code: "S3", name: "Test and measurement" },
  { code: "S4", name: "Support and handling equipment" },
];

// Support Equipment SNS codes
export const SNS_CODES_SUPPORT = [
  { code: "A", name: "Measuring, testing and adjusting" },
  { code: "B", name: "Signal and power generating, supplying, storing and converting" },
  { code: "C", name: "Communicating, signaling and lighting" },
  { code: "D", name: "Engine and missile system checkout and testing" },
  { code: "E", name: "Gas and liquid supplying, processing, storing and shipping" },
  { code: "F", name: "Personnel and solid material protection" },
  { code: "G", name: "Maintenance and servicing" },
  { code: "H", name: "Handling, moving, stopping, propelling and landing" },
  { code: "J", name: "Heating, cooling, ventilating, humidity control" },
  { code: "K", name: "Firefighting, rescue and survival" },
  { code: "L", name: "Training and simulating" },
  { code: "M", name: "Detecting, ranging and fire control" },
  { code: "N", name: "Demolition and destruction" },
  { code: "O", name: "Flight control and navigation" },
  { code: "P", name: "Ignition systems" },
  { code: "Q", name: "Photographic" },
  { code: "R", name: "Data processing and storing" },
  { code: "S", name: "Automatic test equipment (ATE)" },
];

// Combined for convenience - all SNS codes
export const ALL_SNS_CODES = [...SNS_CODES, ...SNS_CODES_LAND, ...SNS_CODES_SUPPORT];
